import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";
import { BellRing, Check } from "lucide-react";
import { toast } from "sonner";
import { getSubscription, permission, pushSupported, needsHomeScreen } from "@/lib/push";
import { HomeScreenHint } from "@/components/CustomerPushPrompt";

export default function OrderPushButton({ orderId, finished }) {
  const [on, setOn] = useState(false);
  const [busy, setBusy] = useState(false);

  const link = useCallback(async (ask) => {
    const sub = await getSubscription(ask);
    if (!sub) return false;
    await api.post(`/orders/${orderId}/push/subscribe`, sub);
    setOn(true);
    return true;
  }, [orderId]);

  useEffect(() => {
    if (pushSupported() && permission() === "granted") link(false).catch(() => {});
  }, [link]);

  if (finished) return null;
  if (needsHomeScreen()) return <div className="mt-6"><HomeScreenHint /></div>;
  if (!pushSupported()) return null;

  if (on)
    return (
      <p className="mt-6 text-sm flex items-center gap-2 text-emerald-600 font-medium" data-testid="order-push-active">
        <Check className="w-4 h-4" /> Você vai receber uma notificação a cada mudança no pedido.
      </p>
    );

  const enable = async () => {
    setBusy(true);
    try {
      const ok = await link(true);
      if (!ok) toast.error(permission() === "denied" ? "Notificações bloqueadas. Libere nas configurações do navegador." : "Permissão não concedida.");
    } catch {
      toast.error("Não foi possível ativar as notificações.");
    } finally {
      setBusy(false);
    }
  };

  return (
    <button onClick={enable} disabled={busy} data-testid="order-push-enable-btn"
      className="mt-6 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-5 py-2.5 text-sm font-semibold hover:bg-primary/90 transition-colors disabled:opacity-60">
      <BellRing className="w-4 h-4" /> {busy ? "Ativando..." : "Receber avisos deste pedido no celular"}
    </button>
  );
}
